// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    ancestorId: z.string().min(1).max(21),
    descendantId: z.string().min(1).max(21),
    distance: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    ancestorId: z.string().min(1).max(21),
    descendantId: z.string().min(1).max(21),
    distance: z.number(),
});
export const OrganizationClosure = Object.freeze({
    table: 'organization_closure',
    tableSingular: 'organization_closure',
    fields: {
        tenantId: 'tenant_id',
        ancestorId: 'ancestor_id',
        descendantId: 'descendant_id',
        distance: 'distance',
    },
    fieldKeys: [
        'tenantId',
        'ancestorId',
        'descendantId',
        'distance',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
